import DropdownDialogWithPointerWrapper from '../../components/DropdownDialogWithPointerWrapper'
import PasswordHint from './PasswordHint'

export default class PasswordHintTooltip extends DropdownDialogWithPointerWrapper {
    constructor(policyManager, options) {
        super({
            toggleMode: true,
            dialogOffsets: {
                top: 0, left: 0
            },
            additionalClass: "passwordHintDialog",
            ...options,
            dialog: new PasswordHint({policyManager}),
        });
    }


}


// WEBPACK FOOTER //
// ./web/js/util/passwords/PasswordHintTooltip.js